import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=15d8fde2&scoped=true"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"
import style0 from "./Conference.vue?vue&type=style&index=0&id=15d8fde2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8fde2",
  null
  
)

export default component.exports